<div class="checklist-item {{key}}">
  <div class="item-content">
    {{#if actionTip}}<p class="tip">{{t actionTip}}</p>{{/if}}
    <p>
      {{t text}}
      {{#if link}}<a href="{{link.url}}" target="_blank">{{#if link.text}}{{t link.text}}{{else}}{{link.url}}{{/if}}</a>{{/if}}
    </p>
  </div>
</div>
